import { useEffect, useState, useCallback } from "react";
import { getInvoicesByHistoryId } from "../../api/invoiceService";
import { getInvoicesByHistoryEntryId } from "../../api/invoiceService";
import { getInvoicesByPetId } from "../../api/invoiceService";
export const useInvoices = (historyId, entryId, petId, mode, trigger, initialPage = 1, initialLimit = 10) => {
    const [invoices, setInvoices] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'pet')
              {
                response = await getInvoicesByPetId(petId, page, limit);
              }
              else {
                if (entryId)
                {
                  response = await getInvoicesByHistoryEntryId(entryId, page, limit);
                } else {
                  response = await getInvoicesByHistoryId(historyId, page, limit);
                }
              }
              setInvoices(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch invoices:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = invoices.pagination.page + 1;
        if (nextPage <= invoices.pagination.totalPages) {
        await fetchData(nextPage, invoices.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, invoices.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { invoices, loading, loadMore, searchFunction, resetParent };
};